// Log in as user, the browser's side. The server owns the session
// (apps/server/src/impersonation.mjs): it sets an HttpOnly cookie this code
// never sees, answers every /api request as the person viewed, and says so in
// /api/me's `impersonatedBy`. Here: start and end it. viewAsStorage.ts keeps
// this browser's remembered UI state apart while it lasts.
import { authenticatedFetch } from './authClient';

/** Where the app goes once a session starts or ends: a full load, so nothing from before is still on screen. */
const HOME = '/';

/** Starts viewing as `personId`, then reloads the app as them. Throws the server's message when it refuses. */
export async function startViewAs(personId: string): Promise<void> {
  const response = await authenticatedFetch(`/api/setup/users/${encodeURIComponent(personId)}/impersonate`, { method: 'POST' });
  if (!response.ok) {
    const body = (await response.json().catch(() => ({}))) as { error?: unknown };
    throw new Error(typeof body.error === 'string' ? body.error : 'Could not log in as this user.');
  }
  window.location.assign(HOME);
}

/** Ends the session, if there is one. Best effort: on sign-out the session also ends on its own within the hour. */
export async function endViewAs(reason?: 'sign_out'): Promise<void> {
  try {
    await authenticatedFetch(`/api/impersonation${reason ? `?reason=${reason}` : ''}`, { method: 'DELETE' });
  } catch {
    // Signed out already, or offline: the server ends it at expiry, and it never outlives the admin's own sign-in.
  }
}

/** Exit: ends the session and reloads the app as the admin. */
export async function exitViewAs(): Promise<void> {
  await endViewAs();
  window.location.assign(HOME);
}
